import { QuestionSection } from '@osmosis/shared/types/learndb/learnData';
import { QuizType } from '@osmosis/shared/types/quiz';

import { QuizItem } from '../../../../types/quiz';
import { getLoggedOutCount } from '../../../../app/_components/quiz/utils';
import { learnQuizRoute } from '../../../../lib/quiz/route';

/**
 * Returns pageName.
 */
export const getPageName = (concept?: string | string[]) => {
  let pageName = '';

  if (concept) {
    if (Array.isArray(concept)) {
      pageName = encodeURIComponent(
        concept.map((c) => decodeURIComponent(c)).join('/'),
      );
    } else {
      pageName = concept;
    }
  }

  return pageName;
};

/**
 * Returns processed Questions with quiz url.
 */
export const processQuestions = async (
  isActiveUser: boolean,
  getHandler: (list: number[]) => Promise<QuizItem[]>,
  initQuestions: QuestionSection,
  concept?: string | string[],
) => {
  if (isActiveUser) {
    return initQuestions;
  } else {
    const questionSets = Object.entries(initQuestions).map(([key, value]) => ({
      key,
      value,
    }));

    return await Promise.all(
      questionSets.map(async (set) => {
        if (!set.value.list.length || set.key === 'cme') {
          return { [set.key]: set.value };
        } else {
          const items = await getHandler(set.value.list);
          const loggedOutCount = getLoggedOutCount(items);
          const hasFlashcardItems = items.some(
            (item) => item.subtype === QuizType.Flashcard,
          );
          const isDisabled =
            hasFlashcardItems ||
            (loggedOutCount < 2 && set.value.list.length >= 3) ||
            set.value.list.length <= 2;

          const url = learnQuizRoute({
            pageName: getPageName(concept),
            quizTag: set.key,
            quizType: 'questions',
            resume: false,
          });

          if (!isDisabled) {
            return { [set.key]: { ...set.value, quizUrl: url } };
          } else {
            return { [set.key]: set.value };
          }
        }
      }),
    );
  }
};
